import React from 'react';
import { BrainCircuit, Bot, Sparkles } from 'lucide-react';
export function Authority() {
  return <section className="py-20 bg-graphite text-white relative overflow-hidden" data-id="element-34">
      {/* Background tech pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#22D3EE 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-35"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-36">
        <div className="text-center mb-12" data-id="element-37">
          <div className="inline-flex items-center justify-center p-3 bg-white/10 rounded-2xl mb-6 backdrop-blur-sm" data-id="element-38">
            <BrainCircuit className="w-8 h-8 text-accent" data-id="element-39" />
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6" data-id="element-40">
            De la Curva de Aprendizaje a la Eficiencia Total
          </h2>
        </div>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10 backdrop-blur-md" data-id="element-41">
          <ul className="space-y-8" data-id="element-42">
            <li className="flex items-start gap-4" data-id="element-43">
              <div className="bg-primary/20 p-3 rounded-lg flex-shrink-0 mt-1" data-id="element-44">
                <Bot className="w-6 h-6 text-primary" data-id="element-45" />
              </div>
              <div data-id="element-46">
                <p className="text-xl font-medium text-white mb-2" data-id="element-47">
                  Esto no es un curso de ventas tradicional: es un protocolo de{' '}
                  <span className="text-accent font-bold" data-id="element-48">IA Consultiva</span>.
                </p>
                <p className="text-gray-400" data-id="element-49">
                  No te enseñamos teoría aburrida. Te entregamos un sistema
                  listo para implementar hoy mismo.
                </p>
              </div>
            </li>

            <li className="flex items-start gap-4" data-id="element-50">
              <div className="bg-accent/20 p-3 rounded-lg flex-shrink-0 mt-1" data-id="element-51">
                <BrainCircuit className="w-6 h-6 text-accent" data-id="element-52" />
              </div>
              <div data-id="element-53">
                <p className="text-xl font-medium text-white mb-2" data-id="element-54">
                  Usas a ChatGPT como tu{' '}
                  <span className="text-accent font-bold" data-id="element-55">
                    Director de Ventas personal
                  </span>
                  .
                </p>
                <p className="text-gray-400" data-id="element-56">
                  Analizas el mensaje, detectas el miedo oculto y envías la
                  respuesta exacta. La IA hace el trabajo pesado de pensar.
                </p>
              </div>
            </li>

            <li className="flex items-start gap-4" data-id="element-57">
              <div className="bg-success/20 p-3 rounded-lg flex-shrink-0 mt-1" data-id="element-58">
                <Sparkles className="w-6 h-6 text-success" data-id="element-59" />
              </div>
              <div data-id="element-60">
                <p className="text-xl font-medium text-white mb-2" data-id="element-61">
                  No eres tú contra el cliente; eres tú + tu{' '}
                  <span className="text-accent font-bold" data-id="element-62">
                    'Cerebro de Ventas'
                  </span>{' '}
                  guiando hacia el pago.
                </p>
                <p className="text-gray-400" data-id="element-63">
                  Elimina la fricción, la ansiedad y la duda. Convierte el
                  proceso de venta en una conversación fluida y natural.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}